import {Directive, HostListener, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NgControl} from '@angular/forms';
import {CountryList} from "@service/enum/process-state.enum";

@Directive({
    selector: '[zip-code]',
})
export class ZipcodeDirective implements OnChanges {
    @Input() zipRegex: any;
    @Input() selectedCountry: string;

    constructor(public elRef: NgControl) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedCountry.currentValue) {
            this.selectedCountry = changes.selectedCountry.currentValue;
            // tslint:disable-next-line:max-line-length
            this.zipRegex = CountryList.find(country => country.alpha3 === changes.selectedCountry.currentValue || country.alpha2 === changes.selectedCountry.currentValue).zipRegex;
            this.markFieldsAsDirty();
        }
    }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        this.markFieldsAsDirty();
    }

    private markFieldsAsDirty() {
        if (!this.elRef.value) {
            this.elRef.control.setErrors({'required': true});
            return;
        }
        if (this.selectedCountry && this.zipRegex) {
            const zipRegex = new RegExp(this.zipRegex)
           const isValid = zipRegex.test(this.elRef.value)

            if(!isValid) {
                this.elRef.control.setErrors({'not-valid': true});
            } else {
                this.elRef.control.setErrors(null);
            }

        }


    }

}
